module.exports = __webpack_public_path__ + "static/media/slide-8.6b2b8a92.jpg";